'use client';

import { format as formatDate } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { FC, useEffect, useState } from 'react';

import { ScClockUTC } from './styled';

interface ClockUTCProps {
  format?: string;
}

export const ClockUTC: FC<ClockUTCProps> = ({
  format = 'yyyy-MM-dd HH:mm:ss',
}) => {
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const utcTime = toZonedTime(currentTime, 'UTC');

  return <ScClockUTC>{formatDate(utcTime, format)} (UTC)</ScClockUTC>;
};
